import React from "react";
import { observer } from "mobx-react";
import UiMeet3dNotificationSettingsPage from "~/modules/UiMeet3d/app/UiMeet3dNotificationSettingsPage";
import "../styles/TourIndexHeader.less";
import "../styles/SidePage.less";
import "../styles/TourLayout.less";

const ClientPanelUiMeet3dNotificationSettingsPage = observer(props => <UiMeet3dNotificationSettingsPage {...props} />);

export default ClientPanelUiMeet3dNotificationSettingsPage;
